import { FETCH_SUPPORT_REQUESTS } from '../actions/Support/SupportActionTypes';

const initialState = {
  supportRequests: [],
  loading: false,
  error: null,
};

export function SupportReducer(state = initialState, action) {
  switch (action.type) {
    case 'SUPPORT_REQUESTS_LOADING':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'SUPPORT_REQUESTS_LOADED':
      return {
        ...state,
        loading: false,
      };
    case FETCH_SUPPORT_REQUESTS:
      return {
        ...state,
        supportRequests: action.payload,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
}
